export default class pegLivenessPage extends HTMLElement {
	async connectedCallback() {
		await new Promise(requestAnimationFrame);
		this.abortController = new AbortController();
		this.#setEventListeners();
		this.#trackViewPage();

		// reset checkboxes after navigation back to this page
		setTimeout(() => {
			this.querySelector('#termsAndConditionsReadInput').checked = false;
			this.querySelector('#electronicDisclosureReadInput').checked = false;
		}, 100);
	}

	async disconnectedCallback() {
		await new Promise(requestAnimationFrame);
		this.abortController.abort();
	}

	#setEventListeners() {
		this.querySelector('.startLivenessCheck').addEventListener(
			'click',
			async (event) => {
				if (event.target.classList.contains('disabled')) {
					event.preventDefault();
				} else {
					this.#disableButtonAndCheckboxes();
					this.querySelector('wdk-hintbox-error.tokenError').hide();

					await this.#fetchAccessToken();

					this.#triggerEmailSendout();
					this.#trackClickStartVerify();
				}
			},
			{ signal: this.abortController.signal },
		);

		this.querySelector('#termsAndConditionsRead').addEventListener(
			'change',
			() => {
				this.#toggleStartLivenessCheckButton();
			},
			{ signal: this.abortController.signal },
		);

		this.querySelector('#electronicDisclosureRead').addEventListener(
			'change',
			() => {
				this.#toggleStartLivenessCheckButton();
			},
			{ signal: this.abortController.signal },
		);
	}

	async #fetchSubjectToken() {
		// the subjectToken needs to be fetched via endpoint (and not on pageLoad in ftl) because of its TTL. So it's nice and fresh when the user clicks the button
		try {
			const subjectToken = await fetchIt.get(`/user/verification/liveness/token`);
			return subjectToken.token;
		} catch (error) {
			jPar.util.log.error(error.toString(), 'page_method.fetchTokenToGetTheToken.js fetchTokenToGetTheToken failed');
			location.href = '/login';
			return null;
		}
	}

	#getBrand() {
		let brand;
		if (jPar.wdk.brands.forBrands(['ps'])) {
			brand = 'parship';
		} else if (jPar.wdk.brands.forBrands(['eh'])) {
			brand = 'eharmony';
		} else {
			brand = 'elitepartner';
		}

		return brand;
	}

	async #fetchAccessToken() {
		try {
			const subjectToken = await this.#fetchSubjectToken();
			if (!subjectToken) {
				throw new Error('Kein Subject-Token erhalten');
			}

			const brand = this.#getBrand();
			const startButton = this.querySelector('.startLivenessCheck');
			const accessTokenUrl = startButton.getAttribute('data-access-token-url');
			const gatewayUrl = startButton.getAttribute('data-gateway-url');

			const config = {
				locale: 'en',
				hostAppName: brand,
				hostAppVersion: '1.0.0',
				credentials: btoa(`${brand}:secret`),
				authUrl: accessTokenUrl,
				authToken: subjectToken,
				gatewayUrl: gatewayUrl,
			};

			const chiffre = this.getAttribute('user-id');
			const id = `${brand}:user:${chiffre}`;
			const tmgWebSDK = new TMGWebSDK(config); /* global TMGWebSDK */
			tmgWebSDK.registerProfile(id, {}, (err) => {
				if (err) {
					console.error('error registering profile', err);
					jPar.util.log.error(err, 'fetchAccessToken failed, error registering profile');
					return;
				}

				tmgWebSDK.getJWT((error, JWT) => {
					if (error) {
						this.#enableButtonAndCheckboxes();
						this.querySelector('wdk-hintbox-error.tokenError').show();
						console.error(error);
						return;
					}
					this.#startVerification(JWT);
				});
			});
		} catch (error) {
			this.#enableButtonAndCheckboxes();
			this.querySelector('wdk-hintbox-error.tokenError').show();
			jPar.util.log.error(error.toString(), 'page_method.fetchAccessToken.js fetchAccessToken failed');
			console.error(error);
			return null;
		}
	}

	#startVerification(accessToken) {
		const button = this.querySelector('.startLivenessCheck');
		const redirectUrl = button.getAttribute('data-redirect-url');
		const livenessCheckUrl = button.getAttribute('data-liveness-check-url');

		location.href = livenessCheckUrl + `&access_token=${encodeURIComponent(accessToken)}&redirect_url=${encodeURIComponent(redirectUrl)}`;
	}

	#enableButtonAndCheckboxes() {
		jPar.wdk.loadingIndicator.hide(this.querySelector('.startLivenessCheck'));

		this.querySelector('#termsAndConditionsReadInput').removeAttribute('disabled');
		this.querySelector('#electronicDisclosureReadInput').removeAttribute('disabled');
	}

	#disableButtonAndCheckboxes() {
		jPar.wdk.loadingIndicator.show(this.querySelector('.startLivenessCheck'));

		this.querySelector('#termsAndConditionsReadInput').setAttribute('disabled', '');
		this.querySelector('#electronicDisclosureReadInput').setAttribute('disabled', '');
	}

	async #triggerEmailSendout() {
		// just fetch, no return handling needed
		try {
			await fetchIt.post(`/user/verification/liveness/triggerEmail`, {});
		} catch (error) {
			jPar.util.log.error(error.toString(), 'page_method.triggerEmailSendout.js triggerEmail/status failed');
			await jPar.util.awaitTimeout(5000); // Chance to have a selfhealing in the Backend
			return 'FAILED';
		}
	}

	#toggleStartLivenessCheckButton() {
		const termsAndConditionsChecked = this.querySelector('#termsAndConditionsReadInput').checked;
		const electronicDisclosureChecked = this.querySelector('#electronicDisclosureReadInput').checked;
		const startLivenessCheckButton = this.querySelector('.startLivenessCheck');
		const buttonShouldBeEnabled = termsAndConditionsChecked && electronicDisclosureChecked;

		startLivenessCheckButton.classList.toggle('disabled', !buttonShouldBeEnabled);
	}

	#trackViewPage() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'liveness_verification_initialization',
			action: 'page_view',
		});
	}

	#trackClickStartVerify() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'liveness_verification_initialization',
			action: 'click',
			targetId: 'click_button_verify',
		});
	}
}
